export function isDifferent(a: Record<string, any>, b: Record<string, any>, fields: string[]): boolean {
  return fields.some((field) => {
    const fieldA = a[field];
    const fieldB = b[field];

    const fieldAResolved = fieldA ?? null;
    const fieldBResolved = fieldB ?? null;

    return fieldAResolved !== fieldBResolved;
  });
}

export function createHashMask() {
  const hashLength = 6;
  return '•'.repeat(hashLength);
}
